import React from 'react';
import { CheckCircle2Icon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
type ProductShowcaseProps = {
  variant?: 'abundance' | 'details';
};
const includedItems = ['Más de 100 planificaciones completas', 'Más de 250 recursos educativos', 'Proyectos y secuencias didácticas', 'Efemérides y material imprimible', 'Cuentos, audiocuentos y moldes', 'Recursos creativos para tu sala'];
export function ProductShowcase({
  variant = 'abundance'
}: ProductShowcaseProps) {
  const isDetails = variant === 'details';
  return <section className={isDetails ? 'bg-white py-10 sm:py-14 md:py-20' : 'bg-slate-900 py-10 text-white sm:py-14 md:py-20'} data-id="element-137">
      <div className="container mx-auto px-4 md:px-6" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.45
      }} className={`mx-auto text-center ${isDetails ? 'max-w-4xl' : 'max-w-3xl'}`} data-id="element-139">
          <div className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-extrabold uppercase tracking-wide ${isDetails ? 'bg-pink-100 text-pink-700' : 'bg-yellow-300 text-slate-900'}`} data-id="element-140">
            <SparklesIcon className="h-4 w-4" data-id="element-141" />
            {isDetails ? '¿Qué recibís exactamente?' : 'Mirá todo lo que te espera'}
          </div>
          <h2 className={`mt-3 text-3xl font-black leading-tight tracking-tight sm:text-4xl ${isDetails ? 'text-slate-900' : 'text-white'}`} data-id="element-142">
            {isDetails ? <>Un respaldo enorme para que no vuelvas a empezar de cero.</> : <>No es “una planificación”. Es gran parte de tu año resuelto.</>}
          </h2>
          <p className={`mx-auto mt-3 max-w-2xl text-base leading-relaxed sm:text-lg ${isDetails ? 'text-slate-600' : 'text-slate-300'}`} data-id="element-143">
            {isDetails ? 'Todo queda en un solo lugar para que, cuando llegue una necesidad, tengas por dónde empezar sin abrir veinte pestañas.' : 'Propuestas, materiales e ideas para acompañarte semana tras semana, sin comprar recursos por separado.'}
          </p>

          {isDetails ? <div className="mx-auto mt-6 grid max-w-4xl grid-cols-2 gap-2.5 text-left sm:grid-cols-3 sm:gap-3" data-id="element-144">
              {includedItems.map((item, index) => <motion.div key={item} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04
          }} className="rounded-2xl border border-orange-100 bg-orange-50/70 p-3 sm:p-4" data-id="element-145">
                  <p className="text-sm font-extrabold leading-snug text-slate-800 sm:text-base" data-id="element-146">
                    {item}
                  </p>
                </motion.div>)}
            </div> : <div className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-2.5 text-left" data-id="element-147">
              <div className="rounded-2xl bg-white/10 p-3 ring-1 ring-white/15" data-id="element-148">
                <p className="text-2xl font-black text-yellow-300" data-id="element-149">+100</p>
                <p className="mt-0.5 text-xs font-bold leading-snug text-white" data-id="element-150">
                  planificaciones completas
                </p>
              </div>
              <div className="rounded-2xl bg-white/10 p-3 ring-1 ring-white/15" data-id="element-151">
                <p className="text-2xl font-black text-yellow-300" data-id="element-152">+250</p>
                <p className="mt-0.5 text-xs font-bold leading-snug text-white" data-id="element-153">
                  recursos para tu sala
                </p>
              </div>
            </div>}

          {!isDetails && <p className="mx-auto mt-5 flex max-w-md items-start gap-2 text-left text-sm font-bold leading-relaxed text-yellow-100" data-id="element-154">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 flex-shrink-0 text-yellow-300" data-id="element-155" />
              Una compra para dejar de resolver la planificación semana a
              semana.
            </p>}
        </motion.div>
      </div>
    </section>;
}